<template>
  <div>
    <Header :title="$t('card.title')" />
    <div class="full-page-box">
      <div class="card-box">
        <p style="line-height: 1.4">{{ $t("card.msg") }}</p>
        <van-form @submit="onSubmit">
          <van-cell-group>
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("card.name") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              v-model="usrname"
              :placeholder="$t('card.name')"
              :rules="[{ required: true }]"
            >
              <template #left-icon>
                <div class="icon">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 448 512"
                    class="text-primary w-5 h-5"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
                    ></path>
                  </svg>
                </div>
              </template>
            </van-field>

            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("card.item1") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
            readonly
              clickable
              class="input"
              v-model="dob"
              :placeholder="$t('card.item1')"
              :rules="[{ required: true }]"
              @click="dobshow = true"
            >
              <template #left-icon>
                <div class="icon">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 448 512"
                    class="text-primary w-5 h-5"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
                    ></path>
                  </svg>
                </div>
              </template>
            </van-field>
            <van-calendar color="rgb(4 109 181)" :min-date="minDate" :max-date="maxDate" v-model="dobshow" @confirm="ondobConfirm"  confirm-text="Hoàn thành" :title="$t('card.item1')"
            confirm-disabled-text="Vui lòng chọn thời gian kết thúc" />

            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("card.cardno") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              v-model="usrcard"
              :placeholder="$t('card.cardno')"
              :rules="[{ required: true }]"
            >
              <template #left-icon>
                <div class="icon">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 24 24"
                    class="text-primary w-5 h-5"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.0049 6.99979H21.0049C21.5572 6.99979 22.0049 7.4475 22.0049 7.99979V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H18.0049V6.99979ZM4.00488 8.99979V18.9998H20.0049V8.99979H4.00488ZM4.00488 4.99979V6.99979H16.0049V4.99979H4.00488ZM15.0049 12.9998H18.0049V14.9998H15.0049V12.9998Z"
                    ></path>
                  </svg>
                </div>
              </template>
            </van-field>

            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("card.item2") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
            readonly
              clickable
              class="input"
              v-model="cccd"
              :placeholder="$t('card.item2')"
              :rules="[{ required: true }]"
              @click="cccdshow = true"
            >
              <template #left-icon>
                <div class="icon">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 448 512"
                    class="text-primary w-5 h-5"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
                    ></path>
                  </svg>
                </div>
              </template>
            </van-field>
            <van-calendar color="rgb(4 109 181)" :min-date="minDate" :max-date="maxDate" v-model="cccdshow" @confirm="oncccdConfirm"  confirm-text="Hoàn thành" :title="$t('card.item2')"
            confirm-disabled-text="Vui lòng chọn thời gian kết thúc" />
            <p class="desc">{{ $t("card.desc") }}</p>
            <p class="desc">{{ $t("card.desc1") }}</p>
            <van-field :label="$t('card.img1')" label-width="120">
              <template #input>
                <van-uploader
                  v-model="uploader1"
                  multiple
                  :max-count="1"
                  preview-size="200"
                />
              </template>
            </van-field>
            <van-field :label="$t('card.img2')" label-width="120">
              <template #input>
                <van-uploader
                  v-model="uploader2"
                  multiple
                  :max-count="1"
                  preview-size="200"
                />
              </template>
            </van-field>
            <van-field :label="$t('card.img3')" label-width="120">
              <template #input>
                <van-uploader
                  v-model="uploader3"
                  multiple
                  :max-count="1"
                  preview-size="200"
                />
              </template>
            </van-field>
          </van-cell-group>
          <div style="margin: 20px 0">
            <van-button v-if="!checkCard()"
              block
              class="btn"
              native-type="submit"
              v-show="!isfinish"
              >{{ $t("common.confirm") }}</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header";
import { Toast } from "vant";
export default {
  name: "UsrCard",
  components: { Header },
  data() {
    return {
      usrname: null,
      dob:null,
      usrcard: null,
      cccd:null,
      uploader1: [],
      uploader2: [],
      uploader3: [],
      isfinish: false,
      usrdata:{},
      dobshow:false,
      cccdshow:false,
      maxDate: new Date(),
      minDate: new Date(1940, 0, 1),
    };
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ name: "login" });
    } else {
      this.getInfo();
    }
  },
  methods: {
    checkCard(){
        return (this.usrdata.bankName
                && this.usrdata.identification
                && this.usrdata.identificationBack
                && this.usrdata.identificationFront
                && this.usrdata.identificationWithHand
                && this.usrdata.dob
                && this.usrdata.cccd
                && this.usrdata.bankName.length > 0
                && this.usrdata.identification.length > 0
                && this.usrdata.identificationBack.length > 0
                && this.usrdata.identificationFront.length > 0
                && this.usrdata.identificationWithHand.length > 0
                && this.usrdata.dob.length > 0
                && this.usrdata.cccd.length > 0
              )
    },
    onSubmit() {
      if(!(this.uploader1 && this.uploader1.length > 0 && this.uploader1[0].content.length > 0)){
        Toast(this.$t('card.img1'))
        return
      }
      if(!(this.uploader2 && this.uploader2.length > 0 && this.uploader2[0].content.length > 0)){
        Toast(this.$t('card.img2'))
        return
      }
      if(!(this.uploader3 && this.uploader3.length > 0 && this.uploader3[0].content.length > 0)){
        Toast(this.$t('card.img3'))
        return
      }

      this.$http({
        method: "post",
        data: {
          bankName: this.usrname,
          identification: this.usrcard,
          identificationBack: this.uploader1[0].content,
          identificationFront: this.uploader2[0].content,
          identificationWithHand: this.uploader3[0].content,
          dob:this.dob,
          cccd:this.cccd
        },
        url: "setIdentity",
      }).then((res) => {
        if (res.code == 200) {
          Toast(res.msg);
        } else {
          Toast(res.msg);
        }
      });
    },
    getInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.usrdata = res.data
            this.usrname = res.data.bankName;
            this.usrcard = res.data.identification;
            this.dob = res.data.dob
            this.cccd = res.data.cccd
            if (
              res.data.identificationBack &&
              res.data.identificationBack.length > 0
            ) {
              this.uploader1 = [
                {
                  file: {},
                  status: "",
                  message: "",
                  url: res.data.identificationBack,
                },
              ];
            }

            if (
              res.data.identificationFront &&
              res.data.identificationFront.length > 0
            ) {
              this.uploader2 = [
                {
                  file: {},
                  status: "",
                  message: "",
                  url: res.data.identificationFront,
                },
              ];
            }

            if (
              res.data.identificationWithHand &&
              res.data.identificationWithHand.length > 0
            ) {
              this.uploader3 = [
                {
                  file: {},
                  status: "",
                  message: "",
                  url: res.data.identificationWithHand,
                },
              ];
            }
          }
        } else {
          Toast(res.msg);
        }
      });
    },
    ondobConfirm(val){
      this.dob = val.getDate() + '/' + (val.getMonth()+1) + '/' + val.getFullYear()
      this.dobshow = false
    },
    oncccdConfirm(val){
      this.cccd = val.getDate() + '/' + (val.getMonth()+1) + '/' + val.getFullYear()
      this.cccdshow = false
    },
  },
};
</script>
<style scoped>
.card-box {
  width: 94%;
  margin: 10px auto;
}
.card-box .input {
  border: 1px solid rgb(4 109 181) !important;
  border-radius: 8px;
}
.card-box .icon {
  color: rgb(4 109 181) !important;
  font-size: 20px;
}
.card-box .desc {
  color: rgb(4 109 181) !important;
  margin-top: 5px;
  line-height: 1.2;
}
.card-box .btn {
  border: 1px solid rgb(4 109 181) !important;
  background-color: rgb(4 109 181);
  color: #fff;
  border-radius: 8px;
}
</style>
